import React, {useEffect, useState} from 'react';
import GenericModal from "../../../components/modal/GenericModal";
import {useForm} from "../../../hooks/useForm/UseForm";
import {getObservarEmpleadoDocumentoAPI,empleadoDocumentoPagoObservarProcesoAPI} from "../../../consumers/backendApisUrls";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import {useSubmitForm} from "../../../hooks/useSubmitForm/useSubmitForm";

const ObservarRegistroModal = ({toggleModal, idEmpleadoDocumentoPago, refreshTable}) => {
    const [submitForm] = useSubmitForm();
    const sectionName = "ObservarRegistroModal";
    const [manageGetRequest] = useManageGetRequest();
    const [formConfigData, setFormConfigData] = useState({});

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);

    const sucessCallbackGetObservarEmpleadoDocumentoPago = function (response) {
        setFormConfigData(response.data);
    }

    const init = async function () {
        await manageGetRequest(getObservarEmpleadoDocumentoAPI(idEmpleadoDocumentoPago),sucessCallbackGetObservarEmpleadoDocumentoPago, false);
    }
    const initialFormValues = {
        "Observacion": ""
    };
    const [formValues, setFormValues] = useState(initialFormValues);
    const [handleChange] = useForm(formValues, setFormValues);

    const successResponseCallback = (response) => {
        refreshTable();
        toggleModal();
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        console.log(formValues.Observacion);
        console.log(idEmpleadoDocumentoPago);
        let payload = {
            "IdEmpleadoDocumentoPago": idEmpleadoDocumentoPago,
            "Observacion": formValues.Observacion
        }
        let keyFiles = ["Observacion"];
        await submitForm(keyFiles, empleadoDocumentoPagoObservarProcesoAPI(), payload, sectionName, successResponseCallback)
    };

    return (        
        <GenericModal showModal={toggleModal} width={"700px"} titulo="Observar Documento de Pago">
            <div className="margin-modal-body">
                <form className="black-color-important">
                    <div className="row custom-form-group-modal mb-0">
                        <label className="col-sm-3 col-form-label modal-label">Colaborador</label>
                        <div className="col-sm-9 flex-row justify-content-center ">
                            <label className="col-sm-9 col-form-label black-color">{formConfigData.nombreEmpleado}</label>
                        </div>
                    </div>
                    <div className="row custom-form-group-modal mb-0">
                        <label className="col-sm-3 col-form-label modal-label">Documento<span className="required"></span></label>
                        <div className="col-sm-9 flex-row justify-content-center ">
                            <label className="col-sm-9 col-form-label black-color">{formConfigData.nomTipoDocumento}&nbsp;{formConfigData.anioTipoDocumento}-{formConfigData.periodoTipoDocumento}</label>
                        </div>
                    </div>
                    <div className="row custom-form-group-modal mb-0">
                        <label className="col-sm-3 col-form-label modal-label">Observación<span className="required">*</span></label>
                        <div className="col-sm-9 flex-row justify-content-center ">
                            <textarea className="form-control" rows="4" name="Observacion" onChange={handleChange} defaultValue={formValues.Observacion} maxLength="200" placeholder={"Máximo 200 caracteres."}></textarea>
                            <p className="ficha-form-input-validation-message" id={`ficha-edit-${sectionName}-Observacion-validation-message`}></p>
                        </div>
                    </div>
                </form>
            </div>
            <div className="modal-footer d-flex justify-content-between pt-0 pb-0">
                <div className="message font-gothan-light align-self-start">
                </div>
                <div className="button align-self-end">
                    <button className="btn btn-primary generic-button-ficha" onClick={onSubmit}>Enviar</button>
                </div>
            </div>
        </GenericModal>        
    )
};
export default ObservarRegistroModal;